function collectBrowserInfo() {
    var _a, _b;
    return {
        colorDepth: window.screen.colorDepth,
        javaEnabled: ((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.javaEnabled) === null || _b === void 0 ? void 0 : _b.call(_a)) || false,
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        timeZineOffset: new Date().getTimezoneOffset(),
    };
}

export { collectBrowserInfo };
//# sourceMappingURL=collectBrowserInfo.js.map
